import { Skeleton } from '@material-ui/lab';

const RatioStatCard = ({ title, value, loading }) => {
	return (
		<div className="bg-white p-24 flex-1 flex flex-col gap-16 rounded-lg">
			<h2 className="text-pd-sm text-gray">{title}</h2>
			<span className="text-pd-2xl font-bold">{loading ? <Skeleton className="w-128 h-36" /> : value}</span>
		</div>
	);
};

export default RatioStatCard;
